export default __webpack_public_path__ + "static/media/Simple-Line-Icons4c82.a7360746.woff2";